import MatrixRow from './MatrixRow';

export default MatrixRow;
